import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import RequestrdProductList from "../../RequestedProduct/index";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
 
const ShopRequestedProductList = (): ReactElement => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
        <div className="content-body_ rounded-2xl">
          <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-0 mb-6">
            <RequestrdProductList inShop={true} getShopId={shopInfo.id} />
          </div>
        </div>
    </React.Fragment> 
  );
};

ShopRequestedProductList.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopRequestedProductList;
